let config = {
    scrollTime: 600,
    bottomMargin: 15,
    hiddenCls: 'refine-search-tooltip--hidden'
};

export default class RefineSearchTooltip {
    constructor(element, options) {
        config = $.extend(config, options);
        this.$element = $(element);
        this.$dismissControl = $('[data-refine-search-tooltip-dismiss]');
        this.$watchForm = $('[data-refine-search-form]');
        this.canShowTooltip = false;
    }

    initTooltip() {
        if (!this.getFromStorage()) {
            this.canShowTooltip = true;
        }
    }

    showTooltip() {
        let scrollTo = this.$element.offset().top - $(window).height() + this.$element.outerHeight() + config.bottomMargin;

        if (this.canShowTooltip) {
            this.$element.removeClass(config.hiddenCls);

            if ($(window).scrollTop() < scrollTo) {
                this.scrollToTooltip({scrollTop: scrollTo}, config.scrollTime);
            }
        }
    }

    dismissTooltip() {
        this.$element.addClass(config.hiddenCls);
        this.canShowTooltip = false;
        this.saveToStorage(true);
        return false;
    }

    scrollToTooltip(properties, speed) {
        $('html, body').animate(properties, speed);
    }

    setListeners() {
        this.$dismissControl
            .off('click.dismiss', '', $.proxy(this, 'dismissTooltip'))
            .on('click.dismiss', $.proxy(this, 'dismissTooltip'));

        this.$watchForm
            .off('form:dirty:change', '', $.proxy(this, 'showTooltip'))
            .one('form:dirty:change', $.proxy(this, 'showTooltip'));
    }

    saveToStorage(data) {
        localStorage.refineSearchTooltipDismissed = data;
    }

    getFromStorage() {
        return localStorage.refineSearchTooltipDismissed === 'true';
    }

    init() {
        this.initTooltip();
        this.setListeners();
    }
}